module.exports = __webpack_public_path__ + "static/07-afb784053c5fc053c363776d769579f5.jpeg";